module.exports = __webpack_public_path__ + "img/Monte_Kope_68.aa1c78d9.jpg";